// Shared by the website, org page and separately bundled shadow-DOM widget.
// Keep the exact field order and provenance identical on every surface.
type Field = { value: unknown; estimated?: boolean };
export type SectionCard = {
  producer?: Field; wine?: Field; vintage?: Field; region?: Field;
  priceRange?: Field; marketActivity?: Field;
  appellation?: Field; cruLevel?: Field; wineStyle?: Field; aging?: Field;
  oakMonths?: Field; bottleFormatMl?: Field; rating?: Field; rarity?: Field;
  catalogVerified?: boolean;
};
export function displayCardValue(field?: Field): string {
  const value = field?.value;
  if (value == null) return "Not available";
  const text = String(value).trim();
  return !text || /^(unknown|not available|null|undefined|n\/a)$/i.test(text) ? "Not available" : text;
}
export function wineCardSections(card: SectionCard) {
  const verified = (field?: Field) => card.catalogVerified === false ||
    (card.catalogVerified !== true && field?.estimated === true)
    ? "Not available" : displayCardValue(field);
  return [
    {
      title: "Verified fields",
      badge: "Verified Data",
      description: "Real iDealwine listing data",
      fields: [
        ["Producer", verified(card.producer)],
        ["Wine name", verified(card.wine)],
        ["Vintage", verified(card.vintage)],
        ["Region", verified(card.region)],
        ["Price Range", verified(card.priceRange)],
        ["Market Activity", verified(card.marketActivity)],
      ],
    },
    {
      title: "Estimated fields",
      badge: "AI Generated",
      description: "AI estimates based on the wine name; not verified listing data",
      fields: [
        ["Appellation", displayCardValue(card.appellation)],
        ["CRU Level", displayCardValue(card.cruLevel)],
        ["Wine Style", displayCardValue(card.wineStyle)],
        ["Aging method", displayCardValue(card.aging)],
        ["Oak (months)", displayCardValue(card.oakMonths)],
        ["Bottle format", displayCardValue(card.bottleFormatMl)],
        ["Critic rating/score", displayCardValue(card.rating)],
        ["Rarity score", displayCardValue(card.rarity)],
      ],
    },
  ];
}
